import React from 'react'

const ChatsNav = () => {
    return (
        <div className="bg-gray-100 text-lg sm:text-xl flex justify-between items-center px-5 flex-1">
            <h1 className="text-blue-500 font-semibold">Edit</h1>
            <h1 className="font-bold">Chats</h1>
            <i class="fa fa-edit  text-blue-500" aria-hidden="false"></i>

        </div>
    )
}

export default ChatsNav
